import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from "@angular/router";
import { map, Observable } from "rxjs";
import { ApplicationContextService } from "src/app/services/application-context.service";

@Injectable({
  providedIn: 'root'
})
export class CanActivatePipelineWaterfallGuard  {

  constructor(private readonly _applicationContextService: ApplicationContextService,
    private readonly _router: Router) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this._applicationContextService.context.pipe(map(context => {
      if (!(context.userPermissions.admin || context.userPermissions.allowPipelineWaterfall)) {
        this._router.navigateByUrl('admin/dashboardv2');
        return false;
      }
      return true;
    }))
  }

  canActivateChild(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.canActivate(next, state);
  }
}
